<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="19"
        viewBox="0 0 23 19"
    >
        <g id="Group_201" data-name="Group 201" transform="translate(-0.5 2.5)">
            <line
                id="Line_78"
                data-name="Line 78"
                x2="20"
                transform="translate(2 -1)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-width="3"
            />
            <line
                id="Line_81"
                data-name="Line 81"
                x2="20"
                transform="translate(2 15)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-width="3"
            />
            <line
                id="Line_79"
                data-name="Line 79"
                x2="7"
                transform="translate(2 7)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-width="3"
            />
            <line
                id="Line_80"
                data-name="Line 80"
                x2="7"
                transform="translate(15 7)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-width="3"
            />
        </g>
    </svg>
</template>
